import { render, staticRenderFns } from "./oil.vue?vue&type=template&id=c15c53ee&scoped=true&"
import script from "./oil.vue?vue&type=script&lang=js&"
export * from "./oil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15c53ee",
  null
  
)

export default component.exports